// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#modalActivityHistory div.modal-body{background-color:#f9f9f9}#cd-timeline>div div.cd-timeline-content>{-webkit-box-shadow:0 3px 0 #ddd;box-shadow:0 3px 0 #ddd}#cd-timeline>div div.cd-timeline-content>h2{font-size:.85rem;padding-top:3%}#cd-timeline>div div.cd-timeline-content>*{font-size:.75rem}#cd-timeline>div div.cd-timeline-content>.cd-date{font-size:.7rem;opacity:.6;padding:.8em 0}", ""]);
// Exports
module.exports = exports;
